import { StreamLanguage, type StringStream } from "@codemirror/language";

/**
 * .pix シナリオ用の最小限のシンタックスハイライト。
 * StreamLanguage を使う(Lezer ベースの本格版は将来)
 */

interface State {
  inChoice: boolean;
}

export const pixLanguage = StreamLanguage.define<State>({
  startState: () => ({ inChoice: false }),

  token(stream: StringStream, state: State): string | null {
    // 行頭
    if (stream.sol()) {
      state.inChoice = false;

      // 空行
      if (stream.eatSpace()) {
        if (stream.eol()) return null;
      }

      // コメント
      if (stream.match(/^\s*(?:;;|\/\/).*$/)) return "comment";

      // ラベル
      if (stream.match(/^## /)) {
        stream.skipToEnd();
        return "heading";
      }

      // ナレーション
      if (stream.match(/^> /)) return "quote";

      // コマンド
      if (stream.match(/^\s*@[A-Za-z_][A-Za-z0-9_]*/)) return "keyword";

      // 選択肢
      if (stream.match(/^\s*-\s+\[/)) {
        state.inChoice = true;
        return "operator";
      }

      // 話者(名前:)
      const speakerMatch = stream.match(/^[^@>:;/\s][^:\n]*:\s/) as RegExpMatchArray | boolean | null;
      if (speakerMatch) {
        return "atom";
      }
    }

    // インラインタグ
    if (stream.match(/\[\/?[^\]]+\]/)) {
      return "string";
    }

    // 数値
    if (stream.match(/-?\b\d+(?:\.\d+)?\b/)) {
      return "number";
    }

    // 16進カラー
    if (stream.match(/#[0-9A-Fa-f]{6}/)) {
      return "number";
    }

    // 識別子(キーワード扱いはせず)
    if (stream.match(/[A-Za-z_][A-Za-z0-9_]*/)) {
      return null;
    }

    // それ以外
    stream.next();
    return null;
  },

  languageData: {
    commentTokens: { line: ";;" },
  },
});
